
import { Section } from "./data-types";

export const EventGeonight: {
	sections: (Section | (() => JSX.Element))[];
} = {
	sections: [
		{
			type: "cards",
			options: {
				columns: 2,
			},
			items: [
				{
					type: "CardItem",
					options: {
						// span: "max"
					},
					data: {
						title: "GeoNight",
						content: () => [
							<p>
								The international "Night of Geography", promoted by EUGEO and IGU, will be held on April 3rd 2026,
								with events taking place on and around this date in April.
								GeoNight is an initiative proposed for the first time by the CNFG
								(French National Geographical Committee) at a National scale in 2017.
								From 2018 onwards, the initiative has expanded internationally, first in Europe,
								thanks to EUGEO, and then even beyond, thanks to the International Geographical Union (IGU).
							</p>,
							<p>
								For further information, see: <a href="https://www.geonight.net/" target="_blank" rel="noopener noreferrer">https://www.geonight.net/</a>
							</p>
						]
					},
				},
				{
					type: "CardImage",
					options: {
					},
					data: {
						media: {
							type: "image",
							src: "/images/examples/4.jpg"
						},
					},
				}
			]
		}
	]
}
